import React, { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import ReactCountryFlag from 'react-country-flag';

const languages = [
  { code: 'en', flag: 'US', name: 'English' },
  { code: 'fi', flag: 'FI', name: 'Suomi' }, // Finnish
  { code: 'de', flag: 'DE', name: 'Deutsch' }, // German
  { code: 'sv', flag: 'SE', name: 'Svenska' }, // Swedish
  { code: 'fr', flag: 'FR', name: 'Français' }, // French
];

const LanguageSelector = () => {
  const { i18n } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    setIsOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const currentLang = languages.find((lang) => lang.code === i18n.language) || languages[0];

  return (
    <div className="relative" ref={dropdownRef}>
      {/* Dropdown Button */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        aria-label="Language selector"
        aria-haspopup="listbox"
        className="flex items-center gap-2 px-3 py-1.5 rounded-full bg-slate-100 hover:bg-slate-200 dark:bg-neutral-800 dark:hover:bg-neutral-700 text-slate-800 dark:text-slate-200 border border-slate-200 dark:border-neutral-700 transition-all text-sm font-medium focus-visible:ring-2 focus-visible:ring-blue-500/50 dark:focus-visible:ring-purple-500/50 outline-none"
      >
        <ReactCountryFlag
          countryCode={currentLang.flag}
          svg
          className="w-5 h-5 rounded-full object-cover"
        />
        <span>{currentLang.name}</span>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className={`h-4 w-4 transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`}
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path
            fillRule="evenodd"
            d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
            clipRule="evenodd"
          />
        </svg>
      </button>

      {/* Dropdown Menu */}
      {isOpen && (
        <div className="absolute right-0 mt-2 w-40 rounded-xl bg-white dark:bg-[#111111] border border-slate-200 dark:border-neutral-800 shadow-xl z-50 overflow-hidden py-1 animate-in fade-in slide-in-from-top-2 duration-200">
          {languages.map((lang) => (
            <button
              key={lang.code}
              onClick={() => changeLanguage(lang.code)}
              className="flex items-center gap-3 px-3 py-2 w-full text-left text-slate-700 dark:text-slate-300 hover:bg-slate-100 dark:hover:bg-neutral-800/80 transition-colors text-sm"
            >
              <ReactCountryFlag
                countryCode={lang.flag}
                svg
                className="w-5 h-5 rounded-sm object-cover"
              />
              <span>{lang.name}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageSelector;